<header class="header">
    <a class="brand" routerLink="/homepage">
        <img class="emblem" src="assets/images/adaa4/uae_emblem.svg" alt="United Arab Emirates" />
        <span class="brand-divider" aria-hidden="true"></span>
        <img class="adaa-logo" [src]="logoSrc()" alt="ADAA" />
    </a>

    <div class="header-actions">
        <button
            class="theme-toggle"
            type="button"
            role="switch"
            [attr.aria-checked]="isDark()"
            [attr.aria-label]="'userBar.theme_' + themeTarget() | translate"
            (click)="themeService.toggle()"
        >
            <span class="theme-thumb" aria-hidden="true">
                <svg class="theme-icon--sun" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="12" r="5" />
                    <path
                        d="M12 1.5v2.5M12 20v2.5M1.5 12H4M20 12h2.5M4.6 4.6l1.8 1.8M17.6 17.6l1.8 1.8M4.6 19.4l1.8-1.8M17.6 6.4l1.8-1.8"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                </svg>
                <svg class="theme-icon--moon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M21 13.2A9 9 0 1 1 10.8 3a7 7 0 0 0 10.2 10.2z" />
                </svg>
            </span>
        </button>

        <a class="icon-btn" routerLink="/homepage/notifications" [attr.aria-label]="'breadcrumbs.communications' | translate">
            <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.7 21a2 2 0 0 1-3.4 0" />
            </svg>
            @if (unreadService.count() > 0) {
                <span class="unread-dot" aria-hidden="true"></span>
            }
        </a>

        <button class="lang-toggle" type="button" (click)="languageService.switchLanguage()">{{ languageLabel() }}</button>
    </div>
</header>
